<div class="row">
    <div class="col-sm-4">
        <div class="card border-primary panel-body">
            <p class="text-on-pannel text-muted"> Nombre panel </p>
            <div class="card-body">
                <div class="card-title">
                    <button class="btn btn-warning">WARNING</button>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque, tempore optio molestias omnis exercitationem odio, magni enim placeat mollitia, iste quidem incidunt officia aut illo alias voluptatum asperiores sit pariatur.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-4">
        <button class="btn btn-primary common-primary">ACEPTAR</button>
        <button class="btn btn-secondary">SECONDARY</button>
        <button class="btn btn-light common-secondary">LIGHT</button>
        <button class="btn btn-info common-secondary">INFO</button>
        <button class="btn btn-success">SUCCESS</button>
        <div class="custom-control custom-">
            <input type="checkbox" class="custom-control-input" id="customSwitch1">
            <label class="custom-control-label" for="customSwitch1"></label>
        </div>
    </div>
    <div class="col-sm-4">
        <div class="row mt-5 mb-3">
            <div class="col-sm-3 mx-0" *ngFor="let item of listSeleccionados">
                <a href="#" class="badge badge-pill badge-secondary">{{item}}
                    <span aria-hidden="true" (click)="seleccionado(item)">&times;</span>
                </a>
            </div>
        </div>
        <select class="form-control" #selectedCategory (change)="seleccionado(selectedCategory.value, true)">
            <option value="">Selecciona una opción</option>
        <option value="Opcion1">Opcion 1</option>
        <option value="Opcion2">Opcion 2</option>
        <option value="Opcion3">Opcion 3</option>
      </select>
        <i class="fa fa-chevron-down"></i>
    </div>
</div>
<div class="row mt-5">
    <div class="col-sm-4">
        <label for="">Forms</label>
        <input type="text" class="form-control">
    </div>
    <div class="col-sm-4">
        <div [innerHTML]="etiqueta"></div>
    </div>
</div>
<div class="row mt-4">
    <div class="col-sm-4">
        <div class="card border-primary panel-body">
            <p class="text-on-pannel text-muted"> Nombre panel </p>
            <div class="card-body">
                <div class="card-title">
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque, tempore optio molestias omnis exercitationem odio, magni enim placeat mollitia, iste quidem incidunt officia aut illo alias voluptatum asperiores sit pariatur.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-4">
        <button class="btn btn-primary common-primary">ACEPTAR</button>
        <button class="btn btn-secondary">SECONDARY</button>
        <button class="btn btn-light common-secondary">LIGHT</button>
        <button class="btn btn-info common-secondary">INFO</button>
        <button class="btn btn-warning">WARNING</button>
        <button class="btn btn-success">SUCCESS</button>
        <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="customSwitch1">
            <label class="custom-control-label" for="customSwitch1"></label>
        </div>
    </div>
    <div class="col-sm-4">
        <div class="row mt-5 mb-3">
            <div class="col-sm-3 mx-0" *ngFor="let item of listSeleccionados">
                <a href="#" class="badge badge-pill badge-secondary">{{item}}
                    <span aria-hidden="true" (click)="seleccionado(item)">&times;</span>
                </a>
            </div>
        </div>
        <form action="">
            <select class="form-control" [(ngModel)]="value" name="value" (ngModelChange)="seleccionado($event)">
            <option [value]="" selected>Selecciona una opción</option>
            <option *ngFor="let p of lista" [ngValue]="p" >{{p.nombre}}</option>
      </select>
            <i class="fa fa-chevron-down"></i>
        </form>
    </div>
</div>
<div class="row mt-5">
    <div class="col-sm-4">
        <label for="">Forms</label>
        <input type="text" class="form-control">
    </div>
    <div class="col-sm-4">
        <div [innerHTML]="etiqueta"></div>
    </div>
    <div class="col-sm-4">
        <label for="customRange1">Example range</label>
        <input type="range" class="custom-range" id="customRange1" (input)="changeValue($event.target.value)">
    </div>
</div>
<app-modal></app-modal>